export default __webpack_public_path__ + "static/media/ctAccessDenied.80d93a6d.svg";